import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M5.432 2.404a1.32 1.32 0 0 1 .526-.11h3.986a1.32 1.32 0 0 1 1.313 1.434l-.001.02-.166 2.714H4.763l-.12-2.738v-.02a1.315 1.315 0 0 1 .789-1.3Zm-.609 5.458h6.18l-.182 2.98a1.316 1.316 0 0 1-1.313 1.191H6.267a1.32 1.32 0 0 1-1.315-1.214l-.129-2.957ZM5.958.895a2.72 2.72 0 0 0-2.713 2.899l.309 7.096v.02a2.715 2.715 0 0 0 2.713 2.523h.982v.956a.7.7 0 1 0 1.4 0v-.956h.86a2.72 2.72 0 0 0 2.707-2.475l.002-.02.435-7.096A2.715 2.715 0 0 0 9.943.895H5.959Zm1.805 9.233a.185.185 0 0 1 .371 0 .185.185 0 0 1-.185.184.185.185 0 0 1-.186-.184Zm.186-1.584a1.585 1.585 0 1 0-.001 3.17 1.585 1.585 0 0 0 0-3.17Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  a
];
function r(c, d) {
  return e(), t("svg", o, [...n]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
